import { render, staticRenderFns } from "./difference.vue?vue&type=template&id=a7c7c2b2&scoped=true&"
import script from "./difference.vue?vue&type=script&lang=js&"
export * from "./difference.vue?vue&type=script&lang=js&"
import style0 from "./difference.vue?vue&type=style&index=0&id=a7c7c2b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c7c2b2",
  null
  
)

export default component.exports